<template>
  <div class="page-container">
    <PageHeader title="试题类型" show-breadcrumb />

    <SearchPanel>
      <span style="color:#909399; font-size:13px; line-height:32px;">试题类型为系统预置字典（单选/多选/判断等），不支持新增与删除。</span>
      <template #actions>
        <el-button type="primary" icon="el-icon-search" size="small" @click="handleSearch">查询</el-button>
        <el-button icon="el-icon-refresh" size="small" @click="handleReset">重置</el-button>
      </template>
    </SearchPanel>

    <TablePanel title="试题类型列表">
      <el-table :data="list" v-loading="loading" size="small" stripe :height="tableHeight">
        <el-table-column type="index" label="序号" width="80" align="center" />
        <el-table-column prop="qttName" label="类型名称" min-width="180" align="center" show-overflow-tooltip />
        <el-table-column prop="qttScoreDefault" label="默认分值" min-width="120" align="center" />
        <el-table-column label="是否可删除" min-width="120" align="center">
          <template slot-scope="{ row }">
            <el-tag size="small" :type="row.canDelete === 1 ? 'success' : 'info'">{{ row.canDelete === 1 ? '允许' : '不允许' }}</el-tag>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        :current-page="page.currentPage"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="page.pageSize"
        :total="page.total"
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="handleSizeChange"
        @current-change="handlePageChange"
      />
    </TablePanel>
  </div>
</template>

<script>
import PageHeader from '@/components/PageHeader.vue'
import SearchPanel from '@/components/SearchPanel.vue'
import TablePanel from '@/components/TablePanel.vue'
import { getZqpkQuestionTopicTypeList } from '@/api/api'

export default {
  name: 'QuestionTopicType',
  components: { PageHeader, SearchPanel, TablePanel },
  data () {
    return {
      loading: false,
      tableHeight: 400,
      list: [],
      page: { currentPage: 1, pageSize: 10, total: 0 }
    }
  },
  created () { this.fetchList() },
  mounted () {
    this.$nextTick(this.calcTableHeight)
    window.addEventListener('resize', this.calcTableHeight)
  },
  beforeDestroy () { window.removeEventListener('resize', this.calcTableHeight) },
  methods: {
    calcTableHeight () {
      const el = this.$el.querySelector('.el-table')
      if (!el) return
      this.tableHeight = window.innerHeight - el.getBoundingClientRect().top - 80
    },
    async fetchList () {
      this.loading = true
      try {
        const params = { currentPage: this.page.currentPage, pageSize: this.page.pageSize }
        const res = await getZqpkQuestionTopicTypeList(params)
        this.list = res.data || []
        this.page.total = res.total || 0
      } catch (e) { this.list = []; this.page.total = 0 } finally { this.loading = false }
    },
    handleSearch () { this.page.currentPage = 1; this.fetchList() },
    handleReset () { this.handleSearch() },
    handleSizeChange (size) { this.page.pageSize = size; this.handleSearch() },
    handlePageChange (page) { this.page.currentPage = page; this.fetchList() }
  }
}
</script>
